import { render, staticRenderFns } from "./RemovePrivateConnectModal.vue?vue&type=template&id=31e18bae&"
import script from "./RemovePrivateConnectModal.vue?vue&type=script&lang=js&"
export * from "./RemovePrivateConnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e18bae')) {
      api.createRecord('31e18bae', component.options)
    } else {
      api.reload('31e18bae', component.options)
    }
    module.hot.accept("./RemovePrivateConnectModal.vue?vue&type=template&id=31e18bae&", function () {
      api.rerender('31e18bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RemovePrivateConnectModal.vue"
export default component.exports